import * as React from 'react';
import { Loader } from './Loader';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../selectors/layout';

export const LoaderContainer: React.FC<{}> = () => {
  const isMobile = useSelector(selectIsMobileLayout);

  return <Loader isMobile={isMobile} />;
};
